module.exports = __webpack_public_path__ + "img/787.47f62fe1.jpg";